// TutorSubmissionRegular.js

import React, { useEffect, useState } from "react";
import "../styles/TutorSubmission.css";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Footer from "../Footer";

const TutorSubmissionRegular = () => {
  const navigate = useNavigate();

  const [step, setStep] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    profile_picture: "",

    institute_id: "",
    institute_custom: "",
    degree_id: "",
    degree_custom: "",
    field_of_study_id: "",
    field_custom: "",

    study_start_year: "",
    study_end_year: "",

    medium_id: [],
    level_id: [],
    subject_id: [],

    division_id: "",
    district_id: "",
    area_id: [],

    teaching_mode: "",
    availability: [],

    gender: "",
    bio: "",
    contact_phone: "",
    contact_whatsapp: "",

    email: "",
    password: "",
    expected_remuneration: "",

    // Important: regular tutors must stay non-verified.
    account_type: "Normal Tutor",
    university_email: "",
    university_email_local: "",
    university_email_domain: "",
    otp: "",
    is_university_verified: false,
  });

  const [options, setOptions] = useState({
    institutes: [],
    degrees: [],
    fields: [],
    mediums: [],
    levels: [],
    subjects: [],
    divisions: [],
    districts: [],
    areas: [],
  });

  const questions = [
    { label: "What's your full name?", key: "name" },
    {
      label: "What's your education institute?",
      key: "institute_id",
      list: "institutes",
      custom: true,
    },
    {
      label: "Your Running Qualification?",
      key: "degree_id",
      list: "degrees",
      custom: true,
    },
    {
      label: "What's your field of study?",
      key: "field_of_study_id",
      list: "fields",
      custom: true,
    },
    {
      label: "Which medium(s) do you want to teach in?",
      key: "medium_id",
      list: "mediums",
      multi: true,
    },
    {
      label: "Level(s) of education you want to teach?",
      key: "level_id",
      list: "levels",
      multi: true,
    },
    {
      label: "Subject(s) you want to teach?",
      key: "subject_id",
      list: "subjects",
      multi: true,
    },
    {
      label: "What's your preferred teaching mode?",
      key: "teaching_mode",
      select: ["Online", "In-person", "Both"],
    },
    {
      label: "Select your weekly availability",
      key: "availability",
      multiSelect: [
        "Saturday",
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
      ],
    },
    {
      label: "Your Location",
      key: "location",
      group: true,
      multiArea: true,
    },
    {
      label: "Gender?",
      key: "gender",
      select: ["Male", "Female"],
    },
    { label: "Write a short bio", key: "bio" },
    {
      label: "Upload your profile picture",
      key: "profile_picture",
      type: "file",
    },
    { label: "Your phone number", key: "contact_phone" },
    {
      label: "Your WhatsApp contact",
      key: "contact_whatsapp",
      button: true,
    },
    { label: "Your email address", key: "email" },
    { label: "Choose a password", key: "password", type: "password" },
  ];

  const current = questions[step];
  const isLast = step === questions.length - 1;
  const isFirst = step === 0;

  const API_BASE_URL =
    process.env.REACT_APP_API_URL || "https://tn.server.goatteachers.com";

  const goToStep = (nextStep) => {
    setErrorMessage("");
    setStep(nextStep);
  };

  useEffect(() => {
    setErrorMessage("");
  }, [step]);

  const normalizeEmail = (email = "") => {
    const trimmed = String(email).trim().replace(/\s+/g, "");
    const parts = trimmed.split("@");

    if (parts.length !== 2 || !parts[0] || !parts[1]) return "";

    return `${parts[0]}@${parts[1].toLowerCase()}`;
  };

  const isValidEmailSyntax = (email) =>
    /^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+$/.test(
      email,
    );

  const extractTutorId = (data) =>
    data?.tutor_id ||
    data?.id ||
    data?.tutor?.id ||
    data?.tutorProfile?.id ||
    data?.user?.id ||
    data?.profile?.id ||
    null;

  const buildProfileUrl = (id) => {
    const origin =
      typeof window !== "undefined" && window.location?.origin
        ? window.location.origin
        : "https://tn.goatteachers.com/";

    return `${origin}/tutor/${id}`;
  };

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const urls = [
          ["institutes", `${API_BASE_URL}/api/institutes`],
          ["degrees", `${API_BASE_URL}/api/degrees`],
          ["fields", `${API_BASE_URL}/api/fields`],
          ["mediums", `${API_BASE_URL}/api/mediums`],
          ["levels", `${API_BASE_URL}/api/levels`],
          ["subjects", `${API_BASE_URL}/api/subjects`],
          ["divisions", `${API_BASE_URL}/api/divisions`],
          ["districts", `${API_BASE_URL}/api/districts`],
          ["areas", `${API_BASE_URL}/api/areas`],
        ];

        const responses = await Promise.all(
          urls.map(([key, url]) =>
            fetch(url).then(async (res) => {
              if (!res.ok) throw new Error(`${key} → ${res.status}`);
              return res.json();
            }),
          ),
        );

        setOptions({
          institutes: responses[0],
          degrees: responses[1],
          fields: responses[2],
          mediums: responses[3],
          levels: responses[4],
          subjects: responses[5],
          divisions: responses[6],
          districts: responses[7],
          areas: responses[8],
        });
      } catch (err) {
        console.error("❌ Failed to fetch dropdown options:", err.message);
      }
    };

    fetchOptions();
  }, [API_BASE_URL]);

  const handleChange = (e) => {
    const { type, name, value, files } = e.target;

    let newValue = type === "file" ? files[0] : value;

    if (name === "name") {
      newValue = value.replace(/\b\p{L}/gu, (m) => m.toUpperCase());
    }

    if (name === "bio") {
      newValue = value.replace(/^(\s*\p{L})/u, (m) => m.toUpperCase());
    }

    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));

    setErrorMessage("");
  };

  const duplicatePhoneToWhatsApp = () => {
    setFormData((prev) => ({
      ...prev,
      contact_whatsapp: prev.contact_phone,
    }));

    setErrorMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const finalEmail = normalizeEmail(formData.email);

    if (!isValidEmailSyntax(finalEmail)) {
      setErrorMessage("Enter a valid email address.");
      return;
    }

    if (!formData.password || formData.password.length < 6) {
      setErrorMessage("Password must be at least 6 characters.");
      return;
    }

    const formDataToSend = new FormData();

    if (formData.profile_picture instanceof File) {
      formDataToSend.append("profile_picture", formData.profile_picture);
    }

    const profile_subjects = [];

    (formData.subject_id || []).forEach((subjectId) => {
      (formData.level_id || []).forEach((levelId) => {
        (formData.medium_id || []).forEach((mediumId) => {
          profile_subjects.push({
            subject_id: parseInt(subjectId, 10),
            level_id: parseInt(levelId, 10),
            medium_id: parseInt(mediumId, 10),
          });
        });
      });
    });

    formDataToSend.append("profile_subjects", JSON.stringify(profile_subjects));

    const areasArray = Array.isArray(formData.area_id)
      ? formData.area_id
      : formData.area_id
        ? [formData.area_id]
        : [];

    formDataToSend.append(
      "areas",
      JSON.stringify(areasArray.map((id) => parseInt(id, 10))),
    );

    const availabilityArray = Array.isArray(formData.availability)
      ? formData.availability
      : typeof formData.availability === "string"
        ? formData.availability.split(",").map((day) => day.trim())
        : [];

    formDataToSend.append("availability", JSON.stringify(availabilityArray));

    formDataToSend.append("password_hash", formData.password);

    const safeYear = (val) =>
      val === "" || val === undefined || val === null
        ? null
        : parseInt(val, 10);

    formDataToSend.append(
      "study_start_year",
      safeYear(formData.study_start_year),
    );
    formDataToSend.append("study_end_year", safeYear(formData.study_end_year));

    const exclude = [
      "password",
      "profile_picture",
      "subject_id",
      "level_id",
      "medium_id",
      "availability",
      "study_start_year",
      "study_end_year",
      "area_id",
    ];

    for (const key in formData) {
      if (!exclude.includes(key) && formData[key] !== undefined) {
        formDataToSend.append(key, formData[key]);
      }
    }

    // Force regular registration from this page.
    formDataToSend.set("email", finalEmail);
    formDataToSend.set("account_type", "Normal Tutor");
    formDataToSend.set("university_email", "");
    formDataToSend.set("university_email_local", "");
    formDataToSend.set("university_email_domain", "");
    formDataToSend.set("otp", "");
    formDataToSend.set("is_university_verified", "false");

    try {
      const res = await fetch(`${API_BASE_URL}/api/tutors/register`, {
        method: "POST",
        body: formDataToSend,
        credentials: "include",
      });

      const data = await res.json();

      if (res.ok) {
        let token = data?.token || null;

        if (token) {
          localStorage.setItem("authToken", token);
        }

        if (!token) {
          try {
            const loginRes = await fetch(`${API_BASE_URL}/api/tutors/login`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              credentials: "include",
              body: JSON.stringify({
                email: finalEmail,
                password: formData.password,
              }),
            });

            const loginData = await loginRes.json();

            if (loginRes.ok && loginData?.token) {
              token = loginData.token;
              localStorage.setItem("authToken", token);
            }
          } catch (loginError) {
            console.warn("Auto-login fallback error:", loginError);
          }
        }

        let id = extractTutorId(data);
        let url = id ? buildProfileUrl(id) : data?.profile_url || "";

        if (!id || !url) {
          try {
            const meRes = await fetch(`${API_BASE_URL}/api/tutors/me`, {
              headers: token ? { Authorization: `Bearer ${token}` } : {},
              credentials: "include",
            });

            const me = await meRes.json();
            const meId = me?.id || me?.tutor?.id || null;

            if (!id && meId) id = meId;
            if (!url && meId) url = buildProfileUrl(meId);
          } catch (meError) {
            console.warn("Fetch /me failed:", meError);
          }
        }

        navigate("/share-profile", {
          replace: true,
          state: {
            id: id || null,
            profileUrl: url || (id ? buildProfileUrl(id) : ""),
          },
        });

        return;
      }

      if (data?.code === "FILE_TOO_LARGE") {
        setErrorMessage(
          "Profile picture is too large. Please upload an image under 5 MB.",
        );
      } else {
        setErrorMessage(`❌ ${data.message || "Registration failed."}`);
      }
    } catch (err) {
      console.error("❌ Submission error:", err);
      setErrorMessage("❌ Network or server error.");
    }
  };

  const renderInput = (q) => {
    const handleSelectChange = (selectedOption, fieldName) => {
      setFormData((prev) => ({
        ...prev,
        [fieldName]: selectedOption ? selectedOption.value : "",
      }));

      setErrorMessage("");
    };

    if (q.group && q.key === "location") {
      return (
        <>
          <Select
            className="custom-select"
            placeholder="Select Division"
            value={
              options.divisions
                .map((d) => ({ value: d.id, label: d.name }))
                .find((opt) => opt.value === formData.division_id) || null
            }
            onChange={(selected) =>
              setFormData((prev) => ({
                ...prev,
                division_id: selected ? selected.value : "",
                district_id: "",
                area_id: [],
              }))
            }
            onMenuOpen={() => setErrorMessage("")}
            onFocus={() => setErrorMessage("")}
            options={options.divisions.map((d) => ({
              value: d.id,
              label: d.name,
            }))}
          />

          <Select
            className="custom-select"
            placeholder="Select District"
            value={
              options.districts
                .map((d) => ({ value: d.id, label: d.name }))
                .find((opt) => opt.value === formData.district_id) || null
            }
            onChange={(selected) =>
              setFormData((prev) => ({
                ...prev,
                district_id: selected ? selected.value : "",
                area_id: [],
              }))
            }
            onMenuOpen={() => setErrorMessage("")}
            onFocus={() => setErrorMessage("")}
            options={options.districts
              .filter(
                (d) =>
                  !formData.division_id ||
                  d.division_id === formData.division_id,
              )
              .map((d) => ({ value: d.id, label: d.name }))}
          />

          <Select
            isMulti
            className="custom-select"
            placeholder="You Can Select Multiple Areas"
            value={(formData.area_id || [])
              .map((areaId) => {
                const areaObj = options.areas.find((a) => a.id === areaId);

                return areaObj
                  ? { value: areaObj.id, label: areaObj.name }
                  : null;
              })
              .filter(Boolean)}
            onChange={(selected) => {
              setFormData((prev) => ({
                ...prev,
                area_id: (selected || []).map((s) => parseInt(s.value, 10)),
              }));

              setErrorMessage("");
            }}
            onMenuOpen={() => setErrorMessage("")}
            onFocus={() => setErrorMessage("")}
            options={options.areas
              .filter(
                (a) =>
                  !formData.district_id ||
                  a.district_id === formData.district_id,
              )
              .map((a) => ({ value: a.id, label: a.name }))}
          />
        </>
      );
    }

    if (q.multiSelect) {
      return (
        <Select
          isMulti
          className="custom-select"
          placeholder={`Select ${q.label}`}
          value={(formData[q.key] || []).map((val) => ({
            value: val,
            label: val,
          }))}
          onChange={(selected) => {
            setFormData((prev) => ({
              ...prev,
              [q.key]: (selected || []).map((s) => s.value),
            }));

            setErrorMessage("");
          }}
          onMenuOpen={() => setErrorMessage("")}
          onFocus={() => setErrorMessage("")}
          options={q.multiSelect.map((opt) => ({ value: opt, label: opt }))}
        />
      );
    }

    if (q.select) {
      return (
        <Select
          className="custom-select"
          placeholder={`Select ${q.label}`}
          value={
            q.select
              .map((opt) => ({ value: opt, label: opt }))
              .find((o) => o.value === formData[q.key]) || null
          }
          onChange={(selected) => handleSelectChange(selected, q.key)}
          onMenuOpen={() => setErrorMessage("")}
          onFocus={() => setErrorMessage("")}
          options={q.select.map((opt) => ({ value: opt, label: opt }))}
        />
      );
    }

    if (q.list) {
      const listOptions = (options[q.list] || []).map((opt) => ({
        value: opt.id,
        label: opt.name,
      }));

      return (
        <Select
          isMulti={!!q.multi}
          className="custom-select"
          placeholder={`Select ${q.label}`}
          value={
            q.multi
              ? (formData[q.key] || []).map((id) => ({
                  value: id,
                  label:
                    (options[q.list] || []).find((opt) => opt.id === id)
                      ?.name || "",
                }))
              : listOptions.find((o) => o.value === formData[q.key]) || null
          }
          onChange={(selected) => {
            setFormData((prev) => ({
              ...prev,
              [q.key]: q.multi
                ? (selected || []).map((s) => s.value)
                : selected?.value || "",
            }));

            setErrorMessage("");
          }}
          onMenuOpen={() => setErrorMessage("")}
          onFocus={() => setErrorMessage("")}
          options={listOptions}
        />
      );
    }

    if (q.key === "email") {
      return (
        <div className="university-email-box">
          <p
            className="simple-hint"
            style={{
              margin: "8px 0 10px",
              fontSize: "0.95rem",
              lineHeight: 1.35,
            }}
          >
            Enter your email address.
          </p>

          <input
            type="email"
            name="email"
            placeholder="example@gmail.com"
            value={formData.email || ""}
            onChange={(e) => {
              setFormData((prev) => ({
                ...prev,
                email: e.target.value,
                university_email: "",
                university_email_local: "",
                university_email_domain: "",
                otp: "",
                is_university_verified: false,
              }));

              setErrorMessage("");
            }}
            autoComplete="email"
          />
        </div>
      );
    }

    if (q.key === "password") {
      return (
        <div className="password-field-wrapper">
          <input
            type={showPassword ? "text" : "password"}
            name={q.key}
            value={formData[q.key] || ""}
            onChange={handleChange}
            placeholder="Choose a password"
            autoComplete="new-password"
          />

          <button
            type="button"
            className="toggle-password-btn"
            onClick={() => {
              setShowPassword((value) => !value);
              setErrorMessage("");
            }}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? "🙈" : "👀"}
          </button>
        </div>
      );
    }

    if (q.key === "contact_phone") {
      return (
        <input
          type="text"
          name="contact_phone"
          value={formData.contact_phone || ""}
          inputMode="numeric"
          pattern="\d*"
          maxLength={11}
          onChange={(e) => {
            const digits = e.target.value.replace(/\D/g, "").slice(0, 11);

            setFormData((prev) => ({
              ...prev,
              contact_phone: digits,
            }));

            setErrorMessage("");
          }}
          placeholder="Enter your 11-digit phone number"
          autoComplete="tel"
        />
      );
    }

    if (q.key === "contact_whatsapp" && q.button) {
      return (
        <>
          <input
            type="text"
            name="contact_whatsapp"
            value={formData.contact_whatsapp || ""}
            onChange={handleChange}
            placeholder="WhatsApp Number"
          />

          <button
            type="button"
            className="copy-button"
            onClick={duplicatePhoneToWhatsApp}
          >
            Click me if same as phone number
          </button>
        </>
      );
    }

    if (q.type === "file") {
      return (
        <input
          type="file"
          accept="image/*,.heic,.heif"
          name={q.key}
          onChange={handleChange}
        />
      );
    }

    return (
      <input
        type={q.type || "text"}
        name={q.key}
        value={formData[q.key] || ""}
        onChange={handleChange}
        placeholder="Type your answer here..."
      />
    );
  };

  const validateCurrentStepAndContinue = (e) => {
    e.preventDefault();

    const q = questions[step];
    const key = q.key;

    if (key === "location") {
      if (!formData.division_id) {
        setErrorMessage("Please select a Division.");
        return;
      }

      if (!formData.district_id) {
        setErrorMessage("Please select a District.");
        return;
      }

      if (!Array.isArray(formData.area_id) || formData.area_id.length === 0) {
        setErrorMessage("Please select at least one Area.");
        return;
      }

      if (isLast) {
        setErrorMessage("");
        handleSubmit(e);
      } else {
        goToStep(step + 1);
      }

      return;
    }

    if (q.type === "file" && !(formData.profile_picture instanceof File)) {
      setErrorMessage("⚠️ Please upload your profile picture.");
      return;
    }

    const customFieldMap = {
      institute_id: "institute_custom",
      degree_id: "degree_custom",
      field_of_study_id: "field_custom",
    };

    if (customFieldMap[key]) {
      const customKey = customFieldMap[key];
      const hasSelect = !!formData[key];
      const hasCustom =
        typeof formData[customKey] === "string" &&
        formData[customKey].trim().length > 0;

      if (!hasSelect && !hasCustom) {
        setErrorMessage("Please select from the list or type your answer.");
        return;
      }
    } else {
      const val = formData[key];

      if (
        val === "" ||
        val === undefined ||
        val === null ||
        (Array.isArray(val) && val.length === 0)
      ) {
        setErrorMessage("⚠️ Please fill out this field before continuing.");
        return;
      }
    }

    if (key === "contact_phone") {
      const digits = String(formData.contact_phone || "").replace(/\D/g, "");

      if (digits.length !== 11) {
        setErrorMessage("❌ Phone number must be exactly 11 digits.");
        return;
      }
    }

    if (key === "contact_whatsapp") {
      const digits = String(formData.contact_whatsapp || "").replace(/\D/g, "");

      if (digits.length !== 11) {
        setErrorMessage("❌ WhatsApp number must be exactly 11 digits.");
        return;
      }
    }

    if (key === "email") {
      const finalEmail = normalizeEmail(formData.email);

      if (!isValidEmailSyntax(finalEmail)) {
        setErrorMessage("Enter a valid email address.");
        return;
      }

      setFormData((prev) => ({
        ...prev,
        email: finalEmail,
      }));
    }

    if (key === "password") {
      if (!formData.password || formData.password.length < 6) {
        setErrorMessage("Password must be at least 6 characters.");
        return;
      }
    }

    if (isLast) {
      setErrorMessage("");
      handleSubmit(e);
    } else {
      goToStep(step + 1);
    }
  };

  return (
    <>
      <div className="form-container">
        {step === 0 && <div className="mx-auto max-w-xl p-6 shadow-sm"></div>}

        <form onSubmit={validateCurrentStepAndContinue}>
          <p className="step-indicator">
            {step < 10
              ? `${step + 1} → Let's start with the basics`
              : `${step + 1} → Continue filling out your info`}
          </p>

          {errorMessage && (
            <div className="form-error-message">{errorMessage}</div>
          )}

          <label className="question-label">{current.label}</label>

          <div className="input-field">{renderInput(current)}</div>

          <div className="form-nav-buttons">
            {!isFirst && (
              <button
                type="button"
                className="nav-button back"
                onClick={() => goToStep(step - 1)}
              >
                ← Back
              </button>
            )}

            <button className="ok-button" type="submit">
              {isLast ? "Apply & Register" : "Next →"}
            </button>
          </div>
        </form>
      </div>

      <Footer />
    </>
  );
};

export default TutorSubmissionRegular;
